import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef
} from '@angular/core';
import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular';
import { Router } from '@angular/router';
import { CpmService } from 'app/service/cpm.service';
import { environment } from '../../../environments/environment';
import { ExportExcelService } from 'app/service/export-excel.service';
import { ExistingListedSecuritiesComponent } from 'app/market-level/existing-listed-securities/existing-listed-securities.component';
import { HistoricalIndicesComponent } from 'app/market-level/historical-indices/historical-indices.component';

@Component({
  selector: 'app-market-level-historical-data',
  templateUrl: './market-level-historical-data.component.html',
  styleUrls: ['./market-level-historical-data.component.scss']
})
export class MarketLevelHistoricalDataComponent implements OnInit {
  @ViewChild(HistoricalIndicesComponent)
  historicalIndices: HistoricalIndicesComponent;
  @ViewChild(ExistingListedSecuritiesComponent)
  existingListed: ExistingListedSecuritiesComponent;

  startYear = 1975;

  loadGraphFirstTime = true;
  initialChart() {
    if (this.loadGraphFirstTime) {
      this.historicalIndices.markData('');
      this.existingListed.setDataGraph(this.startYear);
    }
    this.loadGraphFirstTime = false;
  }

  constructor(
    private router: Router,
    private cpmService: CpmService
  ) { }

  ngOnInit() { }

  exportFunctionsHistoricalData() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmailHistoricalData(
        this.historicalIndices.marketValue,
        this.cpmService
      )
    );
    arrayOfFunctions.set(
      'print',
      this.exportPrintHistoricalData(this.historicalIndices.marketValue)
    );
    arrayOfFunctions.set(
      'pdf',
      this.exportPdfHistoricalData(this.historicalIndices.marketValue)
    );
    arrayOfFunctions.set(
      'ppt',
      this.exportPptHistoricalData(this.historicalIndices)
    );
    return arrayOfFunctions;
  }

  exportEmailHistoricalData = function (marketValue, service) {
    return function mailsectorPopup() {
      service.saveHistoricalIndiesPdfFile(marketValue).then(filename => {
        const subject = 'Historical Indices and market cap';
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
      });
    };
  };


  exportPrintHistoricalData = function (marketValue) {
    return function historicalPrint() {
      const popupWin = window.open(
        `/#/historicalIndices/${marketValue}`,
        '_blank',
        'width=850px,height=1024px'
      );
    };
  };


  exportPdfHistoricalData = function (marketValue) {
    const service = this.cpmService;
    return function historicalPdf() {
      service.downloadFile(
        `${
        environment.cpmBaseUrl
        }/pdf/historicalIndices?marketValue=${marketValue}`
      );
    };
  };

  exportPptHistoricalData(historicalIndices) {
    return function PptHistorical() {
      historicalIndices.Ppt();
    };
  }


  exportExcelHistoricalData(service, indices) {
    return function excelHistoricalData() {
      service.exportHistorical(indices, 'Historical-Data');
    };
  }

  exportFunctionsExistingData() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmailExistingData(
        this.cpmService
      )
    );
    arrayOfFunctions.set('print', this.exportPrintExistingData());
    arrayOfFunctions.set('pdf', this.exportPdfExistingData());
    arrayOfFunctions.set('ppt', this.exportPptExistingData(this.existingListed));
    return arrayOfFunctions;
  }

  exportEmailExistingData = function (service) {
    return function mailsectorPopup() {
      service.saveNewAndExistingListedPdfFile().then(filename => {
        const subject = 'New and Existing Listed Securities';
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
      });
    };
  };

  exportPrintExistingData = function () {
    return function historicalPrint() {
      const popupWin = window.open(
        `/#/existingListedSecurities`,
        '_blank',
        'width=850px,height=1024px'
      );
    };
  };

  exportPdfExistingData = function () {
    const service = this.cpmService;
    return function historicalPdf() {
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/existingListedSecurities`
      );
    };
  };

  exportPptExistingData(existingListed) {
    return function PptExisting() {
      return existingListed.Ppt();
    };
  }

}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/market-level-historical-data/market-level-historical-data.component.ts